import { Outlet } from "react-router-dom";

export const PlayerLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1">
        <Outlet />
      </main>
      {/* La navigation mobile est gérée par MobileLayout dans chaque page */}
    </div>
  );
};